import React, { useState, useRef, useEffect } from 'react';

// components
import PillButton from '../PillButton/PillButton';

// media
import searchIconImg from '../../media/search-icon.svg';

function PropertySearchCompact(props) {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const searchInput = useRef(null);

    return (
        <div className="max-w-2xl">
            <div className="flex rounded-t-4 bg-dark-grey relative w-min text-white z-0">
                <button className="w-24 h-12 rounded-4 flex justify-center items-center relative z-20 font-bold" onClick={() => setActiveTabIndex(0)}>Buy</button>
                <button className="w-24 h-12 rounded-4 flex justify-center items-center relative z-20  font-bold" onClick={() => setActiveTabIndex(1)}>Sell</button>
                <div className={`absolute left-0 top-0 h-full w-1/2 rounded-t-4 z-10 bg-logo-green transition-transform ${activeTabIndex ? 'translate-x-full' : 'translate-x-0'}`}></div>
            </div>
            <div className="relative z-0 transition-all focus-within:scale-110">
                <div className="relative flex pointer-events-none justify-between py-4 px-5 z-20">
                    <img className="pointer-events-none pr-2" src={searchIconImg} alt="Search properties to buy or rent" onClick={() => searchInput.current && searchInput.current.focus()} />
                    <PillButton className="">Search</PillButton>
                </div>
                <input className="absolute rounded-r-full rounded-bl-full focus:rounded-full rounded-tl-none border-grey border border-1 top-0 left-0 h-full w-full z-10 pl-16 focus:shadow-xl focus:outline-none" ref={searchInput}></input>
            </div>
        </div>
    )
}

export default PropertySearchCompact;